import React, { useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Breadcrumb } from 'ksnm-common-ui/lib/Breadcrumb';

import { RoutePath, urlPrefix } from '@components/AppRouter/constants';

import styles from './DesignBreadcrumbs.module.scss';

export const DesignBreadcrumbs = observer(() => {
  const { location } = useHistory();

  const pathSnippets = useMemo(() => location.pathname.split('/').filter((i: string) => i), [location]);

  const breadcrumbNameMap: { [index: string]: string } = useMemo(
    () => ({
      [RoutePath.ORGANIZATIONS]: 'Организация',
      [RoutePath.ACCOUNT]: 'Данные пользователя',
      [RoutePath.LOGS]: 'Мониторинг фоновых процессов',
      [RoutePath.PREPARATION_OF_REPORTS]: 'Реестр подготовки отчетности',
      [RoutePath.REPORTING_TREE]: 'Просмотр отчетности',
      [RoutePath.DICTIONARY_REPORT]: 'Справочник: Отчеты',
      [RoutePath.DICTIONARY_REPORT_VERSION]: 'Справочник: Версии отчетов',
      [RoutePath.DICTIONARY_REPORT_PERIODS]: 'Справочник: Календарь отчетных форм',
      [RoutePath.DICTIONARY_REPORT_SETTINGS]: 'Справочник: Настройка отчетов',
      [RoutePath.DICTIONARY_CONTROLS]: 'Справочник: Контроли',
      [RoutePath.DICTIONARY_CONTROL_GROUPS]: 'Справочник: Группы контролей',
      [RoutePath.DICTIONARY_INDICATORS]: 'Справочник: Показатели',
      [RoutePath.DICTIONARY_CONTROL_VERSIONS]: 'Справочник: Версии контролей',
      [RoutePath.DICTIONARY_CONTROL_APPLICABILITY]: 'Справочник: Применимости контролей',
      [RoutePath.DICTIONARY_COUNTERPARTIES]: 'Справочник: Контрагенты',
      [RoutePath.DATA_CONTROL]: 'Результаты выполнения КП',
      [RoutePath.AUDIT]: 'Аудит действий пользователей',
      [RoutePath.USER_ROLE_REPORT]: 'Отчет по ролям пользователей',
      [RoutePath.SETTING_USER_ROLES]: 'Настройка ролей пользователей',
      [RoutePath.SETTINGS]: 'Общие настройки',
    }),
    [],
  );

  const extraBreadcrumbItems = useMemo(
    () =>
      pathSnippets.map((_: string, index: number) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        return breadcrumbNameMap[url]
          ? {
              title: (
                <Link className={styles.link} to={url}>
                  {breadcrumbNameMap[url]}
                </Link>
              ),
            }
          : undefined;
      }),
    [pathSnippets, breadcrumbNameMap],
  );

  const breadcrumbItems = useMemo(
    () => [
      {
        title: (
          <Link className={styles.link} to={urlPrefix}>
            Главная страница
          </Link>
        ),
      },
      ...extraBreadcrumbItems.filter((f: string) => !!f),
    ],
    [extraBreadcrumbItems],
  );

  return <Breadcrumb className={styles.designBreadcrumbs} separator=">" items={breadcrumbItems} />;
});
